import { AxiosResponse } from '@/interface';
import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/interface/store/';
import * as s_Interface from '@/interface/store/profile';
import * as c_Interface from '@/interface/components/profile';
import * as API from '@/api/profile';
import { File } from '@/interface/components';

export const actions: ActionTree<s_Interface.Profile, RootState> = {
  async signS3(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId, file }: { userId: string; file: File }
  ) {
    try {
      const payload = {
        imagePath: `profile/${userId}/${file.name}`,
      };
      const { data } = await API.signAvatar(userId, payload);
      const result = await API.signResultPut(data.url, file);
    } catch (e) {
      throw e;
    }
  },
  async getProfile({ commit }: ActionContext<s_Interface.Profile, RootState>, userId: string) {
    try {
      const { data } = await API.getUser(userId);
      await commit('SET_PROFILE', data);
      await commit('SET_LAST_GROUP_ID', data.lastGroupId, { root: true });
    } catch (e) {
      throw e;
    }
  },
  async updateProfile(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId, payload }: { userId: string; payload: c_Interface.ChangeProfilePayload }
  ) {
    try {
      const { data }: AxiosResponse = await API.updateUser(userId, payload);
    } catch (e) {
      throw e;
    }
  },
  async deleteProfile({ commit }: ActionContext<s_Interface.Profile, RootState>, userId: string) {
    try {
      const { data } = await API.deleteUser(userId);
    } catch (e) {
      throw e;
    }
  },
  async uploadThumb(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId, file }: { userId: string; file: File }
  ) {
    try {
      const { data }: AxiosResponse = await API.setAvatar(userId, {
        name: file.name,
        url: `https://images.labsby.com/profile/${userId}/${file.name}`,
      });
    } catch (e) {
      throw e;
    }
  },
  async deleteAvatar(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId }: { userId: string }
  ) {
    try {
      const { data }: AxiosResponse = await API.deleteAvatar(userId);
    } catch (e) {
      throw e;
    }
  },
  async getAvatar({ commit }: ActionContext<s_Interface.Profile, RootState>, userId: string) {
    try {
      const { data } = await API.getAvatar(userId);
      commit('SET_AVATAR', data);
    } catch (e) {
      throw e;
    }
  },
  async updatePassword(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId, payload }: { userId: string; payload: c_Interface.ChangePasswordPayload }
  ) {
    try {
      const { data }: AxiosResponse = await API.updatePassword(userId, payload);
    } catch (e) {
      throw e;
    }
  },
  async updateAlarm(
    { commit }: ActionContext<s_Interface.Profile, RootState>,
    { userId, payload }: { userId: string; payload: c_Interface.SetEmailAlarmPayload }
  ) {
    try {
      const { data }: AxiosResponse = await API.updateAlarm(userId, payload);
    } catch (e) {
      throw e;
    }
  },
  async getCreditCards({ commit }, userId: string) {
    try {
      const { data }: AxiosResponse = await API.getCreditCards(userId);
      commit('GET_CREDIT_CARDS', data);
    } catch (e) {
      throw e;
    }
  },
  async setCreditCard(
    { commit },
    { userId, payload }: { userId: string; payload: c_Interface.CreateCcPayload }
  ) {
    try {
      const { data }: AxiosResponse = await API.setCreditCard(userId, payload);
      return data;
    } catch (e) {
      throw e;
    }
  },
  async getCreditCard(
    { commit },
    { userId, creditCardId }: { userId: string; creditCardId: string }
  ) {
    try {
      const { data }: AxiosResponse = await API.getCreditCard(userId, creditCardId);
      commit('GET_CREDIT_CARD_ITEM', data);
    } catch (e) {
      throw e;
    }
  },
  async updateCreditCard(
    { commit },
    {
      userId,
      creditCardId,
      payload,
    }: { userId: string; creditCardId: string; payload: c_Interface.ChangeCcPayload }
  ) {
    try {
      const { data }: AxiosResponse = await API.updateCreditCard(userId, creditCardId, payload);
    } catch (e) {
      throw e;
    }
  },
  async deleteCreditCard(
    { commit },
    { userId, creditCardId }: { userId: string; creditCardId: string }
  ) {
    try {
      const { data }: AxiosResponse = await API.deleteCreditCard(userId, creditCardId);
    } catch (e) {
      throw e;
    }
  },
};
